import React from 'react';
import { configureCampaignsPageHead } from 'app/utils/configurePageHead';
import redirect from 'app/utils/redirect';
import prismicApi from 'app/api/prismicApi';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import { RichText } from 'prismic-reactjs';
import { renderSlices } from 'app/components/misc/PrismicBanner';
import get from 'lodash/get';
import * as S from 'app/components/misc/PageStyled/campaignDetail';
import styled from 'styled-components';
import { media } from 'theme';

const Video = styled.div`
  display: inline-block;
  padding: 0;
  margin: 0;
  width: 100%;
  padding-top: 56%;
  height: 100%;
  position: relative;

  > iframe {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
  }
`;
const EmbedContainer = styled.div`
  ${media.largeAndDown`
    margin: 0 -25px;
  `}

  > iframe {
    ${media.largeAndDown`
    width: 100%;
  `}
  }
`;

class CampaignDetail extends React.Component {
  static async getInitialProps({ query, res }) {
    const { campaignSlug } = query;
    const response = await prismicApi('my.campaign.uid', campaignSlug);
    const doc = get(response, 'results[0].data');
    if (!doc) redirect(res, '/');

    return { doc, campaignSlug };
  }

  render() {
    const { doc, campaignSlug } = this.props;
    const hasVideo = get(doc, 'pre[0].text', false);
    const hasEmbed = get(doc, 'embed[0].text', false);

    let coverImageStyle = {};
    if (doc.coverImage) {
      coverImageStyle = {
        backgroundImage: `url(${doc.coverImage.url})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      };
    }

    const content = doc?.body?.map(slice => renderSlices(slice));

    return (
      <Page withBackground>
        <PageHead
          {...configureCampaignsPageHead(
            doc.pageHead,
            doc.ogImage,
            campaignSlug,
          )}
        />
        <S.Title style={{ ...coverImageStyle }}>
          {RichText.render(doc.pageHead)}
        </S.Title>
        <S.PageContent>
          {hasVideo && (
            <Video>
              <iframe
                width="100%"
                height="100%"
                src={doc.pre[0].text}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="campaign video"
              />
            </Video>
          )}
          {hasEmbed && (
            <EmbedContainer
              dangerouslySetInnerHTML={{ __html: doc.embed[0].text }}
            />
          )}
          {RichText.render(doc.pageDetails)}
          {content}
        </S.PageContent>
      </Page>
    );
  }
}

export default CampaignDetail;
